import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Container,
  Typography,
} from '@mui/material';

function UserAgreement() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />
      <Container maxWidth="lg" style={{ paddingTop: '30px', paddingBottom: '30px' }}>
        
        {/* Titre principal */}
        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Accord de Licence Ouverte
        </Typography>

        {/* Introduction */}
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Le présent accord est conclu entre l’Institut National de Statistique du Burundi, ci-après dénommé INSBU, et vous (personne physique ou entité juridique que vous êtes autorisé à représenter). Votre utilisation des données publiées sur cette Plateforme de Données Ouvertes indique votre acceptation des termes ci-dessous.
        </Typography>

        {/* Définitions */}
        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Définitions
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Données : Tout support, y compris audio, visuel, vidéo, texte, graphique ou tout autre élément que vous pouvez identifier via la plateforme de données ouvertes (ODP) de l’INSBU. Produits à valeur ajoutée : Tout produit dérivé que vous créez en utilisant les données, en totalité ou en partie, conformément aux conditions énoncées dans le présent document.
        </Typography>

        {/* Octroi de Licence */}
        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Octroi de Licence
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          L’INSBU vous accorde (personne physique ou entité juridique que vous êtes autorisé à représenter) une licence mondiale, gratuite et non exclusive vous permettant d’utiliser librement les données, de les copier, modifier, traduire, publier, adapter, distribuer, créer des œuvres dérivées et des produits à valeur ajoutée à des fins commerciales et non commerciales, sous réserve des termes de la présente licence.
        </Typography>

        {/* Attribution */}
        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Attribution
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Vous devez inclure et maintenir l'avis suivant sur tous les droits de licence des données et, si possible, fournir un lien vers cette licence.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Source : INSBU. Contient des informations sous licence selon l’Accord de Licence Ouverte de l’Institut National de la Statistique du Burundi.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Vous devez inclure et conserver l'avis suivant pour tous les produits à valeur ajoutée.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Ce produit a été adapté à partir des informations de l’Institut National de Statistique du Burundi, sous licence selon l’Accord de Licence Ouverte de l’INSBU.
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Conditions d’utilisation : Cette œuvre est diffusée sous licence libre. Elle est attribuée par l’Institut National de la Statistique du Burundi.
        </Typography>

        {/* Limitation */}
        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Limitation
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          La licence accordée ici se limite exclusivement aux données du Burundi publiées sur cette plateforme de données ouvertes et ne s’étend pas aux données, logiciels et codes sources de tiers. Toutes les données de tiers téléchargées depuis la plateforme de données ouvertes du Burundi sont soumises à des conditions de licence distinctes, définies par le tiers concerné.
        </Typography>

        {/* Droits de propriété intellectuelle */}
        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Droits de propriété intellectuelle
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Les droits de propriété intellectuelle que l’Institut National de la Statistique du Burundi détient sur les données restent sa propriété. Les droits de propriété intellectuelle que des tiers détiennent sur les données restent leur propriété. Les droits de propriété intellectuelle relatifs aux produits à valeur ajoutée, tels que reconnus par la loi, vous appartiennent.
        </Typography>

        {/* Durée */}
        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Durée
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Le présent accord prend effet à la date et à l’heure auxquelles vous accédez aux informations et sera automatiquement résilié en cas de violation des termes de la licence.
        </Typography>

        {/* Absence d'approbation */}
        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Absence d’approbation
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Cette licence ne vous confère pas le droit d'utiliser les données d'une manière qui suggère un statut officiel ou une approbation de votre part ou de votre utilisation des données.
        </Typography>

        {/* Clause de non-responsabilité */}
        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Clause de non-responsabilité
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Les données sont fournies « en l’état » sans aucune garantie, y compris les garanties implicites de qualité marchande ou d’adéquation à un usage particulier. L’Institut National de la Statistique du Burundi ne saurait être tenu responsable des dommages résultant de leur utilisation ou interprétation, y compris tout dommage consécutif, punitif, direct ou indirect, ou perte de profits.
        </Typography>

        {/* Droit applicable */}
        <Typography variant="h5" align="justify" gutterBottom style={{ color: '#388E3C', fontWeight: 'bold' }}>
          Droit applicable
        </Typography>
        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6' }}>
          Le présent accord est régi et interprété conformément aux lois du Gouvernement du Burundi.
        </Typography>

      </Container>
      <Footer />
    </div>
  );
}

export default UserAgreement;